import { format as formatDateFns } from 'date-fns'

/**
 *
 * @param {Object} date
 * @param {number} date.day - day of the month; 1 - 31 or empty
 * @param {number} date.month - month of the year; 1 - 12 or empty
 * @param {number} date.year - year - 4 digits
 * @returns Date in ISO format and set to UTC (not local time)
 */
export const getDate = function({ day, month, year }) {
    if(!year) return ''

    let formattedDate = new Date()
    formattedDate.setFullYear(year)

    if(NotEmpty(month) && NotEmpty(day)) { // month and day
        formattedDate.setMonth(month - 1)
        formattedDate.setDate(day)
    } else if(NotEmpty(month)) { // month present; day absent
        formattedDate.setMonth(month - 1)
        formattedDate.setDate(1)
    } else if(NotEmpty(day)) { // month absent; day present
        formattedDate.setMonth(0)
        formattedDate.setDate(day)
    } else { // both absent
        formattedDate.setMonth(0)
        formattedDate.setDate(1)
    }

    formattedDate.setHours(0)
    formattedDate.setMinutes(0)

    return formattedDate
}

/**
 *
 * @param {Date} date
 * @returns date converted to string.
 */
export const formatDate = function(params) {
    const { day, month, year } = params
    const date = getDate({ day, month, year })
    if(!date) return ''

    let format = 'yyyy'

    if(NotEmpty(month)) { //
        format = 'MMM ' + format
    }

    if(NotEmpty(day)) {
        format = 'MMM d, yyyy'
    }

    return formatDateFns(date, format)
}

export const NotEmpty = function(value) {
    return value !== null && value !== '' && value !== undefined
}
